import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { ItemSubCategoriesDto } from '.';


export class AllItemSubCategoryResponse extends GlobalResponseObject{
    data?: ItemSubCategoriesDto[];

    /**
     * 
     * @param status 
     * @param intlCode 
     * @param internalMessage 
     * @param data 
     */
     constructor(status:boolean, intlCode:number, internalMessage:string, data?: ItemSubCategoriesDto[]){
        super(status,intlCode,internalMessage);
        this.status = status;
        this.intlCode = intlCode;
        this.internalMessage = internalMessage;
        this.data = data;
    }
}

